"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveCoApplicantTitleOrMarriageGate = exports.isLegallyMarried = exports.LEGALLY_MARRIED_MARITAL_STATUSES = exports.IS_LEGALLY_MARRIED_BY_STATUS = void 0;
const applicant_1 = require("./applicant");
const homeState_1 = require("./homeState");
// SEPARATED counts as legally married: the deed of trust still needs the spouse's consent. An exhaustive
// Record<MaritalStatus, boolean> so a new enum member forces a decision here rather than silently
// defaulting to not-married.
/** @TranslateToPython */
exports.IS_LEGALLY_MARRIED_BY_STATUS = {
    [applicant_1.MaritalStatus.MARRIED]: true,
    [applicant_1.MaritalStatus.SEPARATED]: true,
    [applicant_1.MaritalStatus.UNMARRIED]: false,
    [applicant_1.MaritalStatus.DOMESTIC_PARTNERSHIP_CIVIL_UNION]: false,
};
// For callers that need the list rather than the predicate — `.includes` checks and SQL IN clauses.
exports.LEGALLY_MARRIED_MARITAL_STATUSES = Object.values(applicant_1.MaritalStatus).filter((status) => exports.IS_LEGALLY_MARRIED_BY_STATUS[status]);
// A string Set so raw form values ('' / unanswered / unknown) miss safely instead of needing a cast.
const LEGALLY_MARRIED_STATUSES = new Set(exports.LEGALLY_MARRIED_MARITAL_STATUSES);
const isLegallyMarried = (status) => status != null && LEGALLY_MARRIED_STATUSES.has(status);
exports.isLegallyMarried = isLegallyMarried;
const MARITAL_STATUSES = new Set(Object.values(applicant_1.MaritalStatus));
const isMaritalStatusAnswered = (status) => status != null && MARITAL_STATUSES.has(status);
// Single source for the co-applicant marital-consistency gate. Every collection surface resolves render and
// submit from here, so those agree — but the notary co-owner path (secondarySignersManager.inputCoApplicantDetails)
// writes this column too, later, so enforcement must not assume the stored value came from here.
// Pure; its own module so aven_types keeps no applicant↔homeState import cycle.
const resolveCoApplicantTitleOrMarriageGate = (inputs) => {
    const isRequired = (0, homeState_1.isCoApplicantTitleOrMarriageRequiredForState)(inputs.propertyState);
    // An unanswered status ('' / null) is never legally married, so this covers "not yet answered" too.
    const bothBorrowersLegallyMarried = (0, exports.isLegallyMarried)(inputs.primaryMaritalStatus) && (0, exports.isLegallyMarried)(inputs.coApplicantMaritalStatus);
    const isQuestionShown = isRequired && bothBorrowersLegallyMarried;
    const resolveRelationshipToSubmit = () => {
        if (!isRequired) {
            return undefined;
        }
        if (!isQuestionShown) {
            return null;
        }
        if (inputs.coApplicantMarriedToPrimary === true) {
            return applicant_1.ParentApplicantRelationshipType.MARRIED;
        }
        if (inputs.coApplicantMarriedToPrimary === false) {
            return applicant_1.ParentApplicantRelationshipType.OTHER;
        }
        return null;
    };
    // texasCoApplicantMarriageRunner (SQL) and ApplicantReport.getMarriageToPrimary (aven_python) re-derive these two flags.
    // texasApplicantsChangedSinceUnderwritingRunner (SQL) re-derives isCoApplicantMarriedToSomeoneElse.
    // coApplicantMarriage.parity.json tests this and the Python copy on the same cases. Change all four together.
    const isCoApplicantMarriedToSomeoneElse = isRequired &&
        (0, exports.isLegallyMarried)(inputs.coApplicantMaritalStatus) &&
        isMaritalStatusAnswered(inputs.primaryMaritalStatus) &&
        (!(0, exports.isLegallyMarried)(inputs.primaryMaritalStatus) || inputs.coApplicantMarriedToPrimary === false);
    const isAnswerMissing = isRequired &&
        (!isMaritalStatusAnswered(inputs.primaryMaritalStatus) || !isMaritalStatusAnswered(inputs.coApplicantMaritalStatus) || (isQuestionShown && inputs.coApplicantMarriedToPrimary === undefined));
    return { isRequired, isQuestionShown, relationshipToSubmit: resolveRelationshipToSubmit(), isCoApplicantMarriedToSomeoneElse, isAnswerMissing };
};
exports.resolveCoApplicantTitleOrMarriageGate = resolveCoApplicantTitleOrMarriageGate;
